import { createContext } from 'react';

export const ModalContext = createContext(false);

export default ModalContext;
